import {
  SET_FILTER,
  RESET_AFFILIATE,
  USER_LOGOUT,
} from '../types';


const defaultState = {
  filter: {
    locations: {
      filterKey: 'all',
      sortKey: 'name',
    },
    workordersList: {
      filterKey: 'open',
      sortKey: '-priority',
    },
    serviceRequests: {
      filterKey: 'open_resolved',
      sortKey: 'delivery',
    },
  },
};

const filter = (state = defaultState.filter, action) => {
  switch (action.type) {
    case SET_FILTER:
      return Object.assign({}, state, action.payload);

    case RESET_AFFILIATE:
    case USER_LOGOUT:
      return Object.assign({}, defaultState.filter);

    default:
      return state;
  }
};

export default filter;



// WEBPACK FOOTER //
// ./src/state/reducers/filter.js